/* Elimest mobil sepet çubuğu: ana "Sepete ekle" butonu ekranda görünmediği her an alttan görünür
   (sayfa açılışı dahil); buton ekrana girince, footer'a gelince ya da galeri çubuğun şeridine değerken gizlenir.
   Basınca ana butonu tetikler (seçili paket/varyant aynen gider).
   Fiyat: Bundlex "Toplam Tutar" (.js-bx-total-price); yoksa ürün fiyatı. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-e-mobil-sepet]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var barButton = bar.querySelector('[data-e-mobil-sepet-buton]');
  var priceEl = bar.querySelector('[data-e-mobil-sepet-fiyat]');
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 749px)');

  var section = null;
  var mainButton = null;
  var buttonVisible = true;
  var footerVisible = false;
  var galleryInZone = false;
  var gallery = null;
  var galleryObserver = null;
  var zoneHeight = 0;
  var queued = false;

  function findMainButton() {
    var scope = document.querySelector('.product-information') || document;
    return scope.querySelector('product-form-component button[name="add"]');
  }

  function readPrice() {
    var form = mainButton && mainButton.closest('product-form-component');
    var total = form && form.querySelector('.js-bx-total-price');
    if (total && total.textContent.trim()) return total.textContent.trim();

    var price = section && section.querySelector('.price');
    if (!price) return '';
    var copy = price.cloneNode(true);
    copy.querySelectorAll('.visually-hidden').forEach(function (el) {
      el.remove();
    });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function render() {
    var show = mobile.matches && !buttonVisible && !footerVisible && !galleryInZone && mainButton && !mainButton.disabled;
    bar.classList.toggle('is-acik', !!show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    barButton.tabIndex = show ? 0 : -1;
    root.classList.toggle('e-mobil-sepet-acik', !!show);
  }

  var buttonObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      buttonVisible = entry.isIntersecting;
    });
    render();
  });

  // Galeri (fotoğraflar + noktalar) ekranın alt şeridindeyken çubuk onları kapatmasın.
  // Kök = ekranın en altındaki çubuk yüksekliği kadar şerit; ekran boyu değişince yeniden kurulur.
  function watchGallery() {
    var height = bar.offsetHeight;
    if (!gallery || !height || height === zoneHeight && galleryObserver) return;
    zoneHeight = height;
    if (galleryObserver) galleryObserver.disconnect();
    var top = Math.max(0, window.innerHeight - height);
    galleryObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          galleryInZone = entry.isIntersecting;
        });
        render();
      },
      { rootMargin: '-' + top + 'px 0px 0px 0px' }
    );
    galleryObserver.observe(gallery);
  }

  var lastInnerHeight = window.innerHeight;
  window.addEventListener('resize', function () {
    if (window.innerHeight === lastInnerHeight) return;
    lastInnerHeight = window.innerHeight;
    zoneHeight = 0;
    watchGallery();
  });

  var footerObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      footerVisible = entry.isIntersecting;
    });
    render();
  });

  function refresh() {
    queued = false;
    var current = findMainButton();
    if (current !== mainButton) {
      if (mainButton) buttonObserver.unobserve(mainButton);
      mainButton = current;
      if (mainButton) buttonObserver.observe(mainButton);
    }
    var currentGallery = section && section.querySelector('media-gallery');
    if (currentGallery !== gallery) {
      gallery = currentGallery;
      galleryInZone = false;
      zoneHeight = 0;
      watchGallery();
    }
    var text = readPrice();
    if (priceEl.textContent !== text) priceEl.textContent = text;
    render();
  }

  function queueRefresh() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  barButton.addEventListener('click', function () {
    if (mainButton && !mainButton.disabled) mainButton.click();
  });

  section = document.querySelector('.product-information') || document.querySelector('main');
  // Varyant değişince tema bloğu yeniden çizer; Bundlex paket seçimi toplamı değiştirir. İkisini de izle.
  if (section) {
    new MutationObserver(queueRefresh).observe(section, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  var footer = document.querySelector('body footer');
  if (footer) footerObserver.observe(footer);

  gallery = section && section.querySelector('media-gallery');
  watchGallery();

  function onMediaChange() {
    zoneHeight = 0;
    watchGallery();
    render();
  }
  if (mobile.addEventListener) mobile.addEventListener('change', onMediaChange);
  else if (mobile.addListener) mobile.addListener(onMediaChange);

  root.classList.add('e-mobil-sepet-hazir');
  refresh();
})();
